import ApplicationCard, { PolicyDetail } from './v1'

export default ApplicationCard
export { PolicyDetail }
